export default "__VITE_ASSET__38771d8e__"